var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Tabs"},[_vm._l((_vm.adjustedTabs),function(t){return _c('a',{key:t.value,class:{TabItem: true, Current: t.value === _vm.value},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selectTab(t.value)}}},[_vm._v(" "+_vm._s(t.title)+" ")])}),_c('span',{staticClass:"Grow"}),_c('span',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }